import { PaginationData } from '@mi-front/core';
import React from 'react';
import { CellProps, Column, Renderer, Row, TableOptions } from 'react-table';
import { MrtTable } from './MrtTable';
import { RawTableProps } from './RawTable';

export type TableColumns<D extends object = Record<string, never>> = ColumnExt<D>[];

type ColumnExt<D extends object = Record<string, never>> = Omit<Column<D>, 'accessor'> & {
  accessor?: string | ((d: D) => any);
  align?: 'left' | 'center' | 'right';
  className?: string;
  style?: React.CSSProperties;
  w?: number;
  Cell?: Renderer<CellProps<D, any>>;
};

export type TableProps<D extends object> = Omit<TableOptions<D>, 'columns'> & {
  columns: ReadonlyArray<ColumnExt<D>>;
  size?: RawTableProps['size'];
  bsProps?: RawTableProps;
  getRowClassName?: (row: Row<any>) => string;
};
interface AsyncTableProps<D extends object = Record<string, never>>
  extends Omit<TableProps<D>, 'data'> {
  readonly data: {
    metadata: PaginationData;
    results: readonly D[];
  };
  readonly onPageChange: (page: number) => any;
  readonly isLoading?: boolean;
  readonly noResults?: React.ReactElement;
  readonly resultsCount?: React.ReactElement;
  readonly noPagination?: boolean;
}
const MRT_ENABLED = true;

interface Props<D extends object> extends Omit<AsyncTableProps<D>, 'data' | 'onPageChange'> {
  readonly data: readonly D[];
  readonly noResults?: React.ReactElement;
}

export function PaginatedTable<D extends object>(p: Props<D>) {
  const { data } = p;

  return (
    <MrtTable
      columns={
        p.columns.map((c: any) => ({
          accessorFn: c.accessor,
          size: c.w ? c.w * 12 : 200,
          header: c.Header,
        })) as any
      }
      data={data as any}
    />
  );
}
